import { InfiniteScroll } from "./InfiniteScroll";
import { useDeviceType } from "@/common/hooks/useDeviceType";
import { deviceTypeEnum } from "@/common/utils/device";
import { useMemo } from "react";
import { useAppStore } from "@/common/store/appStore";

type IProps = {
  fetchMore: () => void;
  hasMore: boolean;
};

export const InfinitePlayerScroll = ({ fetchMore, hasMore }: IProps) => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);
  const deviceType = useDeviceType();

  const isDesktop = useMemo(() => {
    return deviceType === deviceTypeEnum.DESKTOP;
  }, [deviceType]);

  const root = useMemo(() => {
    if (isFullScreen) {
      return ".previewFeed";
    }

    if (!isDesktop) {
      return "#scrollableDiv";
    }
  }, [isDesktop, isFullScreen]);

  return (
    <InfiniteScroll
      fetchMore={fetchMore}
      hasMore={hasMore}
      root={root}
    />
  );
};
